import { useEffect, useRef } from 'react';

const APP_NAME = 'iHeart CNTRL';

/**
 * Set `document.title` while the calling component is mounted.
 * Restores the previous title on unmount so nested routes don't
 * leave stale titles behind.
 *
 * Usage:
 *   useDocumentTitle('Dashboard');
 *   // → "Dashboard — iHeart CNTRL"
 */
export function useDocumentTitle(title: string) {
  const previousTitle = useRef(document.title);

  useEffect(() => {
    const prev = previousTitle.current;
    document.title = title ? `${title} — ${APP_NAME}` : APP_NAME;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
